/* Atlas home hero slideshow, ported from ac-cat-v2 home-hero.js.
   Progress bar per slide, pause on hover (desktop only), swipe (>50px) on touch. Each slide has its own copy.
   A single requestAnimationFrame clock fills the bar and changes slide, so clicking or hovering never desyncs them. */
(function () {
  function init(root) {
    if (root.__homeHero) root.__homeHero();
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var copies = [].slice.call(root.querySelectorAll('[data-copy]'));
    var bars = [].slice.call(root.querySelectorAll('[data-bar]'));
    var n = slides.length;
    var ms = parseInt(root.getAttribute('data-ms'), 10) || 6500;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var k = 0, paused = false, tx = null, raf = 0, last = 0, elapsed = 0;
    var fills = bars.map(function (b) { return b.querySelector('.home-hero__fill'); });

    if (reduce) {
      root.querySelectorAll('video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
    }

    /* One clock drives both the progress bar and the slide change, so they never drift apart */
    function paint() {
      fills.forEach(function (f, j) {
        if (!f) return;
        var p = j < k ? 1 : j > k ? 0 : (reduce || n < 2 ? 1 : Math.min(elapsed / ms, 1));
        f.style.transform = 'scaleX(' + p + ')';
      });
    }
    function tick(t) {
      if (!last) last = t;
      var dt = t - last; last = t;
      if (!paused && !document.hidden) elapsed += Math.min(dt, 100);
      if (elapsed >= ms) { go(k + 1); } else { paint(); }
      raf = requestAnimationFrame(tick);
    }

    function go(i) {
      k = ((i % n) + n) % n;
      elapsed = 0;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === k); });
      copies.forEach(function (c, j) {
        var on = j === k;
        c.classList.toggle('is-active', on);
        if (on) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a').forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      });
      bars.forEach(function (b, j) { b.classList.toggle('is-active', j === k); });
      paint();
    }

    bars.forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-bar'), 10)); }); });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(k - 1); });
    if (next) next.addEventListener('click', function () { go(k + 1); });

    function onEnter() { if (window.innerWidth >= 1040) paused = true; }
    function onLeave() { paused = false; }
    function onTs(e) { tx = e.touches[0].clientX; }
    function onTe(e) {
      if (tx == null) return;
      var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 50) go(k + (dx < 0 ? 1 : -1));
    }
    root.addEventListener('mouseenter', onEnter);
    root.addEventListener('mouseleave', onLeave);
    root.addEventListener('touchstart', onTs, { passive: true });
    root.addEventListener('touchend', onTe);

    go(0);
    if (!reduce && n > 1) raf = requestAnimationFrame(tick);
    root.__homeHero = function () {
      cancelAnimationFrame(raf);
      root.removeEventListener('mouseenter', onEnter);
      root.removeEventListener('mouseleave', onLeave);
      root.removeEventListener('touchstart', onTs);
      root.removeEventListener('touchend', onTe);
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-hero]').forEach(init);
  }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-home-hero]');
    if (!root) return;
    var i = [].slice.call(root.querySelectorAll('[data-slide]')).indexOf(e.target);
    var bar = root.querySelector('[data-bar="' + i + '"]');
    if (bar) bar.click();
  });
})();
